import React from 'react';
import { LocationMarkerIcon as HeroLocationMarkerIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type LocationMarkerIconProps = Omit<IconProps, 'children'>;

export const LocationMarkerIcon: React.FC<LocationMarkerIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroLocationMarkerIcon />
        </Icon>
    );
};
